import type { BackOrigin } from '@online-webinar/router';
import { useBackTarget } from '@online-webinar/router';
import { useTranslation } from 'react-i18next';
import { BackLink } from '../BackLink';

/** A webinar page's back link: to the page it was opened from, else to `fallback`, named after where it goes. */
export const BackToOriginLink = ({ fallback }: { fallback: BackOrigin }) => {
    const { t } = useTranslation();
    const { label, ...target } = useBackTarget(fallback);

    return <BackLink {...target}>{t(label)}</BackLink>;
};
